import {
	DatePicker,
	PickersActionBar,
	DatePickerProps,
	PickerChangeHandlerContext,
} from "@mui/x-date-pickers-pro";
import { Dayjs } from "dayjs";
import { BaseTextFieldProps } from "@mui/material/TextField/TextField";
import { ConditionalNullable } from "src/components/common/inputFields/types.ts";
import { PickersActionBarAction } from "@mui/x-date-pickers/PickersActionBar/PickersActionBar";

export interface AavoDatePickerProps<DisableClearable extends boolean | undefined>
	extends DatePickerProps<Dayjs>,
		Pick<BaseTextFieldProps, "size"> {
	onChangeValidDate?: (date: ConditionalNullable<Dayjs, DisableClearable>) => void;
	errorMessage?: string;
	disableClearable?: DisableClearable;
}

export const AavoDatePicker = <DisableClearable extends boolean | undefined>({
	slots,
	slotProps,
	size,
	onChangeValidDate,
	onChange,
	errorMessage,
	disableClearable,
	...other
}: AavoDatePickerProps<DisableClearable>) => {
	const slotPropsWrapped = {
		...slotProps,
		textField: {
			...{
				size: size,
				error: errorMessage !== undefined,
				helperText: errorMessage,
			},
			...slotProps?.textField,
		},
	};

	const onChangeWrapped = (value: Dayjs | null, context: PickerChangeHandlerContext<any>) => {
		onChange?.(value, context);
		if (onChangeValidDate !== undefined) {
			if (disableClearable === true && value === null) return;

			if (context.validationError === undefined || context.validationError === null) {
				onChangeValidDate(value as ConditionalNullable<Dayjs, DisableClearable>);
			}
		}
	};

	const actions: PickersActionBarAction[] =
		disableClearable === true
			? ["today", "cancel", "accept"]
			: ["today", "clear", "cancel", "accept"];

	return (
		<DatePicker
			slotProps={slotPropsWrapped}
			onChange={onChangeWrapped}
			slots={{
				...slots,
				actionBar: ({ ...actionBarProps }) => {
					return <PickersActionBar {...actionBarProps} actions={actions} />;
				},
			}}
			{...other}
		/>
	);
};
